import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import {
  removeWorkspaceLogo,
  updateWorkspaceBrandName,
  uploadWorkspaceLogo,
} from '@/api/branding/brandingApi';
import type { Branding } from '@/api/branding/brandingApi.types';
import { WORKSPACE_BRANDING_QUERY_KEY } from '@/constants/queryKeys';

interface UploadLogoVariables {
  variant: string;
  file: File;
}

export function useUpdateBrandNameMutation(): UseMutationResult<Branding, Error, string | null> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateWorkspaceBrandName,
    onSuccess: function storeUpdatedBranding(branding) {
      queryClient.setQueryData(WORKSPACE_BRANDING_QUERY_KEY, branding);
    },
  });
}

export function useUploadLogoMutation(): UseMutationResult<Branding, Error, UploadLogoVariables> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: function uploadLogo(variables: UploadLogoVariables) {
      return uploadWorkspaceLogo(variables.variant, variables.file);
    },
    onSuccess: function storeUpdatedBranding(branding) {
      queryClient.setQueryData(WORKSPACE_BRANDING_QUERY_KEY, branding);
    },
  });
}

export function useRemoveLogoMutation(): UseMutationResult<Branding, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: removeWorkspaceLogo,
    onSuccess: function storeUpdatedBranding(branding) {
      queryClient.setQueryData(WORKSPACE_BRANDING_QUERY_KEY, branding);
    },
  });
}
